import Api from "./api";
import OidcManager from "./oidcManager";


export interface Company {
    id?: number;

    company?: string;
    streetAddress?: string;
    streetAddress2?: string;
    city?: string;
    phone?: string;
    license?: string;
    email?: string;
    logo?: any;
}

export class CompaniesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }
    
    load(command: { estimateId: number }): JQueryPromise<Company> {
        return super.get("/api/company", command);
    }

    save(command: Company & { estimateId: number | undefined, saveDefault: boolean, logoUpload: File | undefined }): JQueryPromise<Company> {

        let formData = new FormData();
        formData.append("company", JSON.stringify(command));

        if (command.logoUpload)
            formData.append("logo", command.logoUpload, command.logoUpload.name);

        return super.postForm("/api/company", formData);
    }


    loadDefault(): JQueryPromise<Company> {
        return super.get("/api/company/default", {});
    }

    clearLogo(command: {companyId:number}): JQueryPromise<Company> {
        return super.post("/api/company/ClearCompanyLogo", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/companies.ts